import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subtopic } from 'src/app/models/subtopic.model';
import { TopicStructure } from 'src/app/models/topic-structure.model';
import { Topic } from 'src/app/models/topic.model';

@Component({
  selector: 'app-create-structure-step',
  templateUrl: './create-structure-step.component.html',
  styleUrls: ['./create-structure-step.component.scss'],
  standalone: false
})
export class CreateStructureStepComponent {

  topics: string[] = [];
  selectedTopics: string[] = [];

  @Input() topicStructure?: TopicStructure | null;
  @Output() topicStructureChange: EventEmitter<TopicStructure> = new EventEmitter<TopicStructure>();

  constructor() {}

  ngOnInit() {
    this.topics = this.topicStructure!.topics.map((topic) => topic.topic);
    this.selectedTopics = [...this.topics];
  }

  handleSelectionChange(selTopics: string[]) {
    this.topicStructure?.topics.forEach(topic => topic.checked = selTopics.includes(topic.topic));
  }

  emitStructure() {
    this.topicStructureChange.emit(this.topicStructure!);
  }

  handleTopicSelectedChange(topic: Topic) {
    topic.subtopics.forEach(subtopic => subtopic.checked = topic.checked);
    this.emitStructure();
  }

  handleSubtopicSelectedChange(topic: Topic, subtopic: Subtopic) {
    if (subtopic.checked) {
      topic.checked = true;
    }
    if (topic.subtopics.every(subtopic => !subtopic.checked)) {
      topic.checked =  false;
    }
    this.emitStructure();
  }
}

